import React, { useCallback } from 'react';

import { titleize } from '@admin/components/helpers/titleize';
import type { IItem } from '@admin/types/item';

import { ItemsGrid } from './items_grid';

interface OrderGroup {
  order: {
    id: number;
    account_id: number;
    number: string;
    scheduled: string;
    type: string;
    subtype: string;
    maintenance?: boolean;
  };
  items: IItem[];
}

function formatDateTime(time: string): string {
  const locale = navigator.language || 'en-us';
  return new Date(time).toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

export interface ItemGroupableGridProps {
  groupedItems: OrderGroup[];
  selections: IItem[];
  onSelectionsChange: (selections: IItem[]) => void;
}

export const ItemGroupableGrid: React.FC<ItemGroupableGridProps> = ({
  groupedItems,
  selections,
  onSelectionsChange,
}) => {
  const handleSelect = useCallback(
    (newSelections: IItem[]) => {
      onSelectionsChange(newSelections);
    },
    [onSelectionsChange],
  );

  return (
    <>
      {groupedItems.map((group) => {
        const kindLabel = `${titleize(group.order.type)} - ${titleize(group.order.maintenance ? 'maintenance' : group.order.subtype)}`;

        return (
          <div key={group.order.id}>
            <div className="panel">
              <div className="panel-body clearfix">
                <div className="pull-left">
                  Pickup{' '}
                  <a className="btn-link" href={`/accounts/${group.order.account_id}/orders/${group.order.id}`}>
                    #{group.order.number}
                  </a>
                  <br />
                  {group.items.length} {group.items.length === 1 ? 'Item' : 'Items'}
                </div>

                <div className="pull-right">
                  <div>
                    <strong>Kind: </strong>
                    {kindLabel}
                  </div>
                  <div>
                    <strong>Scheduled:</strong> <span>{formatDateTime(group.order.scheduled)}</span>
                  </div>
                </div>
              </div>
            </div>

            <ItemsGrid items={group.items} selections={selections} onSelect={handleSelect} />
          </div>
        );
      })}
    </>
  );
};
